import { useTheme } from '@mui/styles';

export const usePerformanceCellStyles = () => {
  const theme = useTheme();

  return {
    dataCell: {
      verticalAlign: 'top !important',
    },
    trendingUpIcon: {
      color: '#28D859',
    },
    trendingFlatIcon: {
      color: theme.palette.warning.light,
    },
  };
};
